// extracted by css-extract-rspack-plugin
export default {"UpsellGem":"UpsellGem-module__UpsellGem___uWcaT","UpsellGemNew":"UpsellGem-module__UpsellGemNew___nQYXz"};